<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">数据中心</Breadcrumb-item>
        <Breadcrumb-item>常规生转化率列表</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="50" :show-message="false" label-position="left">
        <Row :gutter="32">
          <Col :span="6" >
            <Form-item label="时间">
              <Date-picker type="date" format="yyyy-MM" placeholder="请选择日期" value-format="yyyy-MM-dd" v-model="queryParam.estimateEndYearMonth" style="width: 100%;"/>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="学导：">
              <admin-user-select :status="1" adminGroupCode="userStudyAdviser" v-model="queryParam.studyConsultantId"></admin-user-select>
            </Form-item>
          </Col>
          <Col :span="2">
            <Form-item>
              <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search" @click="search" >搜索</Button>
            </Form-item>
          </Col>
        </Row>
      </Form>
    </div>
    <div class="btn-wrap">
      <Button type="primary" :loading="exportLoading" :disable="exportLoading" icon="search" @click="exportData">导出</Button>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/dataCenter/finishRenewalRateList"
          :params="queryParam" :onLoading="onLoading"></List>
  </div>
</template>

<script>
    import UnBinStudyModal from '../user/UnBinStudyModal.vue'
    export default {
      components: {
        UnBinStudyModal,
      },
      name: 'finishRenewalRateList',
      data () {
        let $constant = this.$constant
        return {
          exportLoading: false,
          cancelLoading: false,
          searchLoading: false,
          reload: 0,
          queryParam: {
            studyConsultantId: null,
            estimateEndYearMonth: null
          },
          title: [
            {
              title: '预计结课月',
              width: 110,
              align: 'center',
              key: 'estimateEndYearMonth'
            },
            {
              title: '实际结课时间',
              width: 125,
              align: 'center',
              key: 'actualEndYearMonth'
            },
            {
              title: '学生ID',
              width: 100,
              align: 'center',
              key: 'studentId'
            },
            {
              title: '学生姓名',
              align: 'center',
              width: 150,
              key: 'studentName',
            },
            {
              title: '等级',
              width: 150,
              align: 'center',
              key: 'levelName'
            },
            {
              title: '课程类型',
              width: 150,
              align: 'center',
              key: 'courseType',
              render: (h, params) => {
                let courseType = params.row.courseType
                let courseTypeEnum = $constant.getEnum($constant.courseTypeEnum, courseType)
                return h('span', courseTypeEnum && courseTypeEnum.text)
              }
            },
            {
              title: '常规课总课时',
              width: 125,
              align: 'center',
              key: 'studentRoutineNum'
            },
            {
              title: '常规课剩余课时',
              width: 135,
              align: 'center',
              key: 'studentRoutineEndNum',
              render: (h, params) => {
                let studentRoutineNum = params.row.studentRoutineNum
                let studentRoutineEndNum = params.row.studentRoutineEndNum
                return h('span', studentRoutineNum - studentRoutineEndNum)
              }
            },
            {
              title: '常规课课耗',
              width: 110,
              align: 'center',
              key: 'studentRoutineEndNum'
            },
            {
              title: '续费状态',
              width: 100,
              align: 'center',
              key: 'renewalType',
              render: (h, params) => {
                let renewalType = params.row.renewalType
                let renewalTypeEnum = $constant.getEnum($constant.renewalType, renewalType)
                return h('span', renewalTypeEnum && renewalTypeEnum.text)
              }
            },
            {
              title: '续费订单数量',
              width: 125,
              align: 'center',
              key: 'fundCount'
            },
            {
              title: '学导姓名',
              width: 150,
              align: 'center',
              key: 'studyConsultantName'
            },
            {
              title: '课程顾问',
              width: 150,
              align: 'center',
              key: 'adviserName'
            }
          ]
        }
      },
      mounted: function () {
        this.init()
      },
      created: function () {
        this.init()
      },
      methods: {
        init () {

        },
        exportData (type) {
          this.exportLoading = true
          this.$http.get('/dataCenter/finishRenewalRate/exportExcel', {responseType: 'arraybuffer', params: this.queryParam}).then((response) => {
            if (response.data) {
              let blob = new Blob([response.data], {type: 'text/csv'})
              let link = document.createElement('a')
              link.target = '_blank'
              link.href = window.URL.createObjectURL(blob)
              link.download = '结课续费率统计.csv'
              link.click()
              this.exportLoading = false
            } else {
              this.$Message.error(response.msg)
            }
          }).catch((e) => {
            this.exportLoading = false
          })
        },
        search () {
          this.reload = new Date().getTime()
        },
        onLoading (loading) {
          this.searchLoading = loading
        }
      }
    }
</script>

<style lang="less" scoped>
  .btn-wrap {
    text-align: right;
    margin-top: 24px;
    margin-bottom: 12px;
  }
</style>


// WEBPACK FOOTER //
// FinishRenewalRateList.vue?68142eec